<template>
  <div class="comments">
    <van-popup v-model="showVideo" round closeable :style="{ width: '80%', padding: '5%' }">
      <video
        width="96%"
        height="96%"
        controls
        autoplay
        :src="playUrl"
      >
      </video>
    </van-popup>
    <van-row class="my_message">
      <van-search
        v-model="value"
        show-action
        :placeholder="$t('shop.designated_user_placeholder')"
        @search="onSearch"
        :clearable= "false"
      >
        <template #action>
          <div @click="onSearch">{{ $t('btn.search') }}</div>
        </template>
      </van-search>
      <van-col span="24" v-if="is_list">
        <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          :finished-text="$t('onLoad.finished_text')"
          @load="onLoad"
          :offset="10"
        >
          <van-cell v-for="t in list" :key="t.id">
            <van-col v-if="selectType == 1" span="24" class="">
              <van-col span="12" class="my_message_center">
                {{ t.create_time | formatDateFilter }}
              </van-col>
              <van-col span="6" class="my_message_sel" v-if="t.video_url" @click="preview(t.video_url)">{{ $t('other.preview') }}</van-col>
              <van-col span="6" class="my_message_sel" v-if="t.video_url" @click="selectCallback(t.id, t.duration,t.video_url)">{{ $t('other.select') }}</van-col>
            </van-col>
            <van-col v-else span="24" class="">
              <van-col span="12" class="my_message_center">
                {{ t.create_time | formatDateFilter }}
              </van-col>
              <van-col span="4" class="my_message_sel" v-if="t.video_url" @click="preview(t.video_url)">{{ $t('other.preview') }}</van-col>
              <van-col span="4" class="my_message_sel" v-if="t.video_url" @click="select(t.video_url, t.id, t.duration)">{{ $t('other.select') }}</van-col>
<!--              <van-col span="4" class="my_message_sel" v-if="t.video_url" @click="stop()">{{ $t('other.stop') }}</van-col>-->
            </van-col>
          </van-cell>
        </van-list>
      </van-col>
      <van-col span="24" v-else>
        <van-col span="24" class="no-data">
          <img src="../assets/img/zwsl.png"/>
        </van-col>
        <van-col span="24" class="no-data-name">{{ $t('onLoad.No_record') }}</van-col>
      </van-col>
    </van-row>
  </div>
</template>
<script>
import '@/assets/css/style.css'
import axios from 'axios'
import Toast from "vant/lib/toast";
import { formatDate } from '@/utils/datetime'

export default {
  data() {
    return {
      value: undefined,
      finished: false,
      loading: false,
      list: [],
      is_list: true,
      page: 1,
      system_log: '',
      showVideo: false,
      playUrl: '',
      selectType: 0,
      touid: undefined,
    }
  },
  filters: {
    formatDateFilter(time) {
      return formatDate(time, false)
    }
  },
  created: function () {
    this.list = []
    // this.config()
    this.initData()
    this.selectType = this.$route.query.select_type ? this.$route.query.select_type : 1
    this.value = this.$route.query.uid
    this.touid = this.$route.query.uid
    document.title = this.$t('title.system_message')
  },
  methods: {
    onSearch() {
      this.touid = this.value
      this.page = 1
      this.initData()
    },
    onLoad() {
      this.initData()
    },
    config: function () {
      axios.get(this.baseUrlApi + "mapi/public/index.php/api/app_api/vue_config").then(res => {
        console.log(res.data.list);
        this.system_log = res.data.data.system_log;
      })
    },
    initData: function () {
      const uid = this.$route.query.uid;
      const token = this.$route.query.token;
      console.log('dddddddd ')
      axios.get(this.baseUrlApi + "mapi/public/index.php/api/room_api/get_room_recording", {
        params: {
          uid: uid,
          token: token,
          touid: this.touid,
          page: this.page
        }
      }).then(res => {
        const pageData = res.data.data
        console.log(pageData);
        if (res.data.code == 1) {
          if (pageData.data.length > 0) {
            console.log(pageData.data)
            this.list = this.list.concat(pageData.data)
            console.log(this.list)
            this.is_list = true
            this.page = this.page + 1
            this.loading = false
          } else {
            if (this.page == 1) {
              this.is_list = false
            }
            this.loading = true
            this.finished = true
          }
        } else {
          if (this.page == 1) {
            this.is_list = false
          }
          this.loading = true
          if (this.page !== 1) {
            Toast(this.$t('onLoad.No_data_available'))
          }
        }
      })
    },
    jump(url) {
      window.location.href = url;
    },
    preview(url) {
      this.showVideo = true
      this.playUrl = url
      // window.location.href = url;
    },
    // 开播时选择回放
    selectCallback(id, duration,url) {
      window.location.href = "bogo://callbackWebview?id=" + id + "&duration=" + duration + "&url=" + encodeURIComponent(url)
    },
    // 直播界面选择回放
    select(url, id, duration) {
      // window.location.href = url;
      // 执行接口调用腾讯云执行回放操作
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + "mapi/public/index.php/api/room_api/set_room_recording", {
        params: {
          uid: uid,
          token: token,
          room_id: this.$route.query.room_id,
          video_src: url
        }
      }).then(res => {
        const data = res.data.data
        console.log(data)
        if (res.data.code == 1) {
          // 关闭选择回放页面
          window.location.href = "bogo://closeWebview?id=" + id + "&duration=" + duration + "&url=" + encodeURIComponent(url)
        }
      }).catch(e => {
        Toast(this.$t('other.fail'))
      })
    },
    // 终止回放
    stop() {
      // window.location.href = url;
      // 执行接口调用腾讯云执行回放操作
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + "mapi/public/index.php/api/room_api/stop_room_recording", {
        params: {
          uid: uid,
          token: token,
          room_id: this.$route.query.room_id
        }
      }).then(res => {
        const data = res.data.data
        console.log(data)
        if (res.data.code == 1) {
          // 关闭选择回放页面
          window.location.href = "bogo://closeWebview"
        }
      }).catch(e => {
        Toast(this.$t('other.fail'))
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/room_recording.vue